import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import Hero from './components/Hero';
import Dimensions from './components/Dimensions';
import FeaturedDramas from './components/FeaturedDramas';
import MethodSection from './components/MethodSection';
import CategorySection from './components/CategorySection';
import FaqSection from './components/FaqSection';
import Testimonials from './components/Testimonials';
import SubscribeForm from './components/SubscribeForm';
import { dramas } from '@/mocks/dramas';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      name: '剧真档案｜爆料短剧真实事件改编确认与原型人物对照',
      url: 'https://aceasia.cn/',
      inLanguage: 'zh-CN',
      description:
        '爆料短剧的真实事件改编确认、剧情原型人物、改编程度分析与片尾声明解读，并与真实爆料逐条对比。',
    },
    {
      '@type': 'ItemList',
      name: '热门爆料短剧档案',
      itemListElement: dramas
        .slice()
        .sort((a, b) => b.hot - a.hot)
        .slice(0, 4)
        .map((drama, idx) => ({
          '@type': 'ListItem',
          position: idx + 1,
          name: `《${drama.title}》改编对照`,
          url: `https://aceasia.cn/dramas/${drama.id}`,
        })),
    },
  ],
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace('#', ''));
      if (el) {
        window.setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 80);
      }
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar overlay />
      <main className="flex-1">
        <Hero />
        <Dimensions />
        <FeaturedDramas />
        <MethodSection />
        <CategorySection />
        <FaqSection />
        <Testimonials />
        <SubscribeForm />
      </main>
      <Footer />
      <BackToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
    </div>
  );
}